import React from "react";

function Market() {
  return (
    <div className="market">
      <div className="tag_btn wow fadeInUp">Why WeKruit</div>
      <div className="t f_24 wow fadeInUp">
        {" "}
        Your Smartest Case Prep, Start Free Trial Today
      </div>
      <div className="content">
        <div className="box1 wow fadeInUp">
          <div className="tag">WeKruit</div>
          <p className="p1 f_32">10 Days Free Trial</p>
          <p className="p2">
            Practice wherever, whenever — improve with feedback trusted by
            top-tier firms at your fingertips. $34.99/month, cancel anytime.
          </p>
          <div className="info">
            <div className="item">
              <p className="pt">Interactive Mock Interviews</p>
              <div className="des">
                The most realistic tool on the market to simulate actual case
                interviews
              </div>
            </div>
            <div className="item">
              <p className="pt">High-Quality Reports, Expert-Backed</p>
              <div className="des">
                Tailored feedback and benchmarks that help you improve, faster
              </div>
            </div>
            <div className="item">
              <p className="pt">Community That Grows With You</p>
              <div className="des">
                Prep doesn’t have to be lonely. Connect with like minded-peers
              </div>
            </div>
          </div>
        </div>
        <div className="box2 wow fadeInUp">
          <div className="tag">Other Solutions</div>
          <div className="p1">
            <p className="f_32">$ 150-300</p>
            <p>per hour</p>
          </div>
          <p className="p2">
            Costly, clunky, confusing manual alternatives with limited
            availability.
          </p>
          <div className="info">
            <div className="item">
              <p className="pt">Expensive & Inconsistent</p>
              <div className="des">
                $150–300/hr for mock sessions but time spend on "getting to know
                you"
              </div>
            </div>
            <div className="item">
              <p className="pt">Unqualified Mock Partners</p>
              <div className="des">
                Practice partners with good intentions, but little value — more
                time wasted than gained
              </div>
            </div>
            <div className="item">
              <p className="pt">Not Like a Real Interview</p>
              <div className="des">
                Static drills and scripted sessions don’t reflect real case
                dynamics
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Market;
